<template>
  <div>
    <div
      class="assessment-wizard-overlay"
      :class="{activated: activated, 'bg--blue': theme === 'default', 'bg--green': theme === 'green', 'bg--gray': theme === 'gray', 'bg--white': theme === 'white'}">
      <div v-if="theme === 'gray'" class="overlay-content">
        <slot/>
      </div>
      <slot v-else/>
    </div>
    <div
      class="bg-overlay"
      v-if="activated"/>
  </div>
</template>

<script>
export default {
  name: 'AssessmentWizardOverlay',
  props: {
    activated: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.assessment-wizard-overlay {
  width: 672px;
  min-height: 430px;
  max-width: 672px;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 16px;
  position: relative;
  transition: all 0.5s;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1);

  &:not(.bg--gray) {
    padding: 24px 36px;
  }

  &.bg--blue {
    background: @blueLight;
  }

  &.bg--green {
    background: @libraryColorBg;
  }

  &.bg--gray {
    background: @ai-gradient;
    padding: 1px;
    border: none;
  }

   &.bg--white {
    background: white;
    border: none;
    box-shadow: none;
  }

  &.activated {
    z-index: 1002;
    box-shadow: 0 0 60px 8px rgba(0, 0, 0, 0.4);
    margin-top: -10px;
    margin-bottom: 10px;
  }

  .close-button {
    color: black;
    opacity: 0.5;
    &:hover {
      opacity: 0.7;
    }
    float: right;
    cursor: pointer;
  }
}

.overlay-content {
  background-color: #f5f5f5;
  border-radius: 15px;
  padding: 32px 48px;
  min-height: 430px;
}

.bg-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: black;
  opacity: 0.55;
  z-index: 1001;
}
</style>
